import { createFileRoute } from "@tanstack/react-router";

import { AdminAccountsActivityScreen } from "@/features/admin/screens/AccountsActivity";

export const Route = createFileRoute("/_authenticated/(admin)/admin/")({
  loader: ({ context: { trpcQueryUtils } }) => {
    trpcQueryUtils.admin.listAdminActivity.prefetch().catch(console.error);
  },
  component: AdminAccountsActivityScreen,
});
